
import { defineComponent, toRefs } from 'vue';

const component = defineComponent({
  name: '',
  props: {
    tagType: {
      type: Number,
      default: 0, // 0:普通, 1:任务, 2:推演
    },
  },
  setup(props) {
    return { ...toRefs(props) };
  },
});

export default component;
